import LinearProgress from "@mui/material/LinearProgress";
import { Button, Dropdown, Input, Menu } from "antd";
import { AiOutlineSearch } from "react-icons/ai";
import { BsSortAlphaDownAlt, BsSortAlphaUpAlt } from "react-icons/bs";
import { CgSortAz } from "react-icons/cg";
import { GoPackage } from "react-icons/go";
import { ImBoxAdd } from "react-icons/im";
import { MdAddCircleOutline } from "react-icons/md";
import { RiArrowLeftCircleLine } from "react-icons/ri";
import { useHistory, withRouter } from "react-router-dom";
function PageHeader(props) {
  let history = useHistory();

  return (
    <>
      <div className="PageHeader">
        <div className="PageHeader-box1">
          <div onClick={() => history.goBack()}>
            <div className="arrowBack">
              <RiArrowLeftCircleLine style={{ fontSize: 25, margin: 8 }} />
            </div>
          </div>
          <div className="nameScrum">
            <div className="pageName">{props.PageName}</div>
            <div className="devider-ver"></div>
            <div className="PageHeader-txt2">{props.breadScrum}</div>
          </div>
        </div>
        <div style={{ flex: 1 }} />
        <div
          className={
            (props.RightButton || props.FilterButton) && props.SearchBar
              ? "PageHeader-box3"
              : "PageHeader-box2"
          }
        >
          {props.SearchBar2 ? (
            <div>
              <Input
                placeholder="Search By Collection Id"
                autoFocus
                className="PageHeader-Search"
                onPressEnter={(val) => props.SearchBar2(val.target.value)}
                suffix={<AiOutlineSearch style={{ color: "#1e88e5" }} />}
              />
            </div>
          ) : null}
          {props.SearchBar ? (
            <div>
              <Input
                placeholder="Search By Box Number"
                autoFocus
                className="PageHeader-Search"
                onPressEnter={(val) => props.SearchBar(val.target.value)}
                suffix={<AiOutlineSearch style={{ color: "#1e88e5" }} />}
              />
            </div>
          ) : null}
          <div style={{ flex: 1, marginInline: 5 }} />
          {props.RightButton ? (
            <Button
              type="primary"
              onClick={() => props.RightClcik()}
              icon={
                props.RightButton === "Assign" ? null : (
                  <MdAddCircleOutline size={20} style={{ marginRight: 10 }} />
                )
              }
            >
              {props.RightButton}
            </Button>
          ) : null}

          {props.FilterButton ? (
            <Dropdown
              menu={{
                items: [
                  {
                    key: 1,
                    icon: <BsSortAlphaDownAlt />,
                    label: "Latest First",
                    onClick: (val) => props.FilterButton("Latest", val),
                  },
                  {
                    key: 2,
                    icon: <BsSortAlphaUpAlt />,
                    label: "Updated First",
                    onClick: (val) => props.FilterButton("Updated", val),
                  },
                  {
                    key: 3,
                    icon: <GoPackage />,
                    label: "Packed",
                    onClick: (val) => props.FilterButton("Packed", val),
                  },
                  {
                    key: 4,
                    icon: <ImBoxAdd />,
                    label: "Received",
                    onClick: (val) => props.FilterButton("Recieved", val),
                  },
                ],
              }}
            >
              <Button style={{ borderRadius: "8px" }}>
                Sort By <CgSortAz />
              </Button>
            </Dropdown>
          ) : null}
        </div>
      </div>
      {props.loader ? (
        <div style={{ marginTop: -18, marginBottom: 15 }}>
          <LinearProgress color={"primary"} style={{ height: 2 }} />
        </div>
      ) : null}
    </>
  );
}
export default withRouter(PageHeader);
